import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-date-range-icon',
  templateUrl: './date-range-icon.component.svg',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateRangeIconComponent {}
